exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-item[data-v-6ccfbfb2]{display:flex}.dropdown-item img[data-v-6ccfbfb2]{padding-right:10px}.dropdown-item .name[data-v-6ccfbfb2]{display:block;font-weight:700}.dropdown-item .info[data-v-6ccfbfb2]{flex:1 1 auto}", ""]);

// exports
